import * as Sentry from '@sentry/react';
import { HttpResponseErrorBoltServer } from '@bolteu/http-normalizer-bolt-server';
import { HttpClientError, HttpErrorUtils } from '@bolteu/http-client';

export function shouldReportErrorToSentry(error: Error) {
  return (
    !HttpErrorUtils.isInstanceOf(error, HttpResponseErrorBoltServer.ServerResponseError) &&
    !HttpErrorUtils.isInstanceOf(error, HttpResponseErrorBoltServer.MissingPermissionsError) &&
    !HttpErrorUtils.isInstanceOf(error, HttpResponseErrorBoltServer.ValidationError) &&
    !HttpErrorUtils.isInstanceOf(error, HttpResponseErrorBoltServer.EntityNotFoundError) &&
    !HttpErrorUtils.isInstanceOf(error, HttpResponseErrorBoltServer.AuthTokenExpiredError) &&
    !HttpErrorUtils.isInstanceOf(error, HttpResponseErrorBoltServer.HttpStatusError) &&
    !HttpErrorUtils.isInstanceOf(error, HttpClientError.RequestNetworkError) &&
    !HttpErrorUtils.isInstanceOf(error, HttpClientError.RequestAbortError)
  );
}

export const ErrorReporter = {
  captureException(error: unknown) {
    if (error instanceof Error && shouldReportErrorToSentry(error)) {
      Sentry.captureException(error);
    }
  },
  captureMessage(message: string, captureContext?: Sentry.SeverityLevel | Sentry.CaptureContext) {
    Sentry.captureMessage(message, captureContext);
  },
};
